import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ExternalLink } from '@/components/links/external-link';
import { pomConfig } from '@/configs/pom-config';

type ErrorSectionProps = {
  code?: number;
  title: string;
  description: string;
  action: ReactElement;
};

export function ErrorSection({
  code,
  title,
  description,
  action,
}: ErrorSectionProps): ReactElement {
  const { t } = useTranslation('errors');

  return (
    <div className='m-auto text-center'>
      {code && (
        <p className='font-semibold text-base text-primary-default'>{code}</p>
      )}
      <h1 className='mt-4 font-bold text-3xl text-layout-foreground tracking-tight sm:text-5xl'>
        {title}
      </h1>
      <p className='mt-6 text-base text-layout-foreground-secondary leading-7'>
        {description}
      </p>
      <div className='mt-10 flex items-center justify-center gap-x-6'>
        {action}
        <ExternalLink
          className='font-semibold text-layout-foreground text-sm'
          href={pomConfig.support}
        >
          {t('Contact support')}
        </ExternalLink>
      </div>
    </div>
  );
}
